import { Box, ButtonProps } from '@chakra-ui/react';

import SunshineIcon from '../../../../../../../../components/_core/SunshineIcon';
import Text from '../../../../../../../../components/_core/Text';
import locales from './locales';

const AddBeneficiaryButton = (props: ButtonProps) => {
  return (
    <Box
      _hover={{
        backgroundColor: 'grey.200',
        borderColor: 'grey.500',
      }}
      alignItems="center"
      as="button"
      backgroundColor="transparent"
      border="1px dashed"
      borderColor="grey.400"
      borderRadius="radius-8"
      color="primary"
      display="inline-flex"
      gap="space-16"
      justifyContent="center"
      padding="space-16"
      width="100%"
      {...props}
    >
      <SunshineIcon fontSize="font-16" name="plus" />
      <Text fontWeight="weight-500" variant="primary">
        {locales.addBeneficiary}
      </Text>
    </Box>
  );
};

export default AddBeneficiaryButton;
